import type { ScanResponse, ScanResultItem } from "../../types";

export type ScanDiffResult = {
  /** 旧版有、新版已无（按宣称短语对齐）— 视为已修复 */
  resolved: ScanResultItem[];
  /** 新版有、旧版无 — 新增风险点 */
  newRisks: ScanResultItem[];
  /** 两版均仍命中 */
  stillPresent: ScanResultItem[];
};

function normKey(phrase: string): string {
  return phrase.trim().replace(/\s+/g, " ").toLowerCase();
}

function indexByPhrase(items: ScanResultItem[]): Map<string, ScanResultItem> {
  const m = new Map<string, ScanResultItem>();
  for (const it of items) {
    const k = normKey(it.phrase);
    if (k) m.set(k, it);
  }
  return m;
}

/**
 * 对比两次扫描结果（旧 → 新）。对齐键为 `flaggedItems[].phrase` 规范化文本。
 * 用于「改文案后是否改对了」：resolved = 消失的旧违规；newRisks = 新出现的违规。
 */
export function diffScanResponses(
  older: ScanResponse,
  newer: ScanResponse,
): ScanDiffResult {
  const olderItems = Array.isArray(older.flaggedItems) ? older.flaggedItems : [];
  const newerItems = Array.isArray(newer.flaggedItems) ? newer.flaggedItems : [];
  const oMap = indexByPhrase(olderItems);
  const nMap = indexByPhrase(newerItems);

  const resolved: ScanResultItem[] = [];
  const stillPresent: ScanResultItem[] = [];

  for (const [k, oItem] of oMap) {
    if (!nMap.has(k)) {
      resolved.push(oItem);
    } else {
      stillPresent.push(nMap.get(k)!);
    }
  }

  const newRisks: ScanResultItem[] = [];
  for (const [k, nItem] of nMap) {
    if (!oMap.has(k)) {
      newRisks.push(nItem);
    }
  }

  return { resolved, newRisks, stillPresent };
}

export function countHighMedium(items: ScanResultItem[]): number {
  return items.filter((x) => x.risk === "high" || x.risk === "medium").length;
}
